import script from "./Funny videos.vue?vue&type=script&setup=true&lang=js"
export * from "./Funny videos.vue?vue&type=script&setup=true&lang=js"

import "./Funny videos.vue?vue&type=style&index=0&id=5d097ef9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.4_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d097ef9"]])

export default __exports__